(function () {
/* Dev Aastha — PDP V2 (exact theme build)
   Poora script ek IIFE me hai, do wajah se:
     · section ke ek se zyada instance ho to script do baar load hota hai;
       top-level `const` dobara declare hone par POORA doosra script parse-error
       de deta tha. Function scope me ye dikkat khatam.
     · `__daPdpV2` guard doosri baar chalne se rokta hai.
   Mockup ka behaviour JS jaisa ka waisa. Teen farq, teenon zaroori:
     · data-view har .dapdp root pe lagta hai (theme me body hamari nahi)
     · buy box mount nahi hota — wo Ella ka hai, GoKwik usi par tika hai
     · har element lookup null-safe hai, kyunki koi bhi block hataya ja sakta hai
   Generated by mockups/build_theme_pdp_exact.py — HAATH SE EDIT MAT KARO. */
if (window.__daPdpV2) return;
window.__daPdpV2 = 1;

/* gayab element ke liye no-op stand-in */
var NOOP = new Proxy(function () {}, {
  get: function (t, k) {
    if (k === 'value' || k === 'textContent' || k === 'innerHTML') return '';
    if (k === 'dataset' || k === 'style' || k === 'classList') return NOOP;
    if (k === Symbol.toPrimitive || k === 'toString') return function () { return ''; };
    return NOOP;
  },
  set: function () { return true; },
  apply: function () { return NOOP; },
});

var DA = (function () {
  var MQ = window.matchMedia('(min-width:1000px)');
  var subs = [], last = null;
  function roots() { return document.querySelectorAll('.dapdp'); }
  function view() { return MQ.matches ? 'desktop' : 'mobile'; }
  function paint() {
    var v = view();
    roots().forEach(function (r) { r.dataset.view = v; });
    if (v === last) return;
    last = v;
    subs.forEach(function (fn) { try { fn(); } catch (e) {} });
  }
  paint();
  MQ.addEventListener('change', paint);
  /* fallback: devtools emulation aur iOS orientation change pe matchMedia ka
     change event kabhi-kabhi miss hota hai */
  var rt;
  addEventListener('resize', function () {
    clearTimeout(rt); rt = setTimeout(paint, 120);
  }, { passive: true });
  return {
    view: view,
    roots: roots,
    onViewChange: function (fn) { subs.push(fn); },
    /* Mockup ka JS har element ke hone ki ummeed karta hai — mockup me poora
       page uska tha. Theme me gallery, price, picker sab Ella ke hain, to
       #rail / #shotRow / #dots jaise ids hote hi nahi. Sirf null lauta dena
       kaafi nahi tha: `null.addEventListener` throw karke POORE script ko
       wahin maar deta tha (isi se FAQ list aur delivery chalte hi nahi the).
       Isliye gayab element ki jagah ek chup-chaap no-op object jaata hai —
       jo maujood hai wo waisa hi chalta hai, jo nahi hai wo kuch nahi karta. */
    el: function (id) {
      return document.getElementById(id) || NOOP;
    },
  };
})();
/* ---------- responsive view ----------
   Theme build: data-view har .dapdp root pe DA lagata hai. Yahan sirf wo
   renders dobara chalte hain jo view badalne pe badalte hain. */
function applyView(){
  faqAll = false;
  if (typeof renderFaq === 'function') renderFaq();
  if (typeof renderGallery === 'function') renderGallery();
}
DA.onViewChange(applyView);

function mountBuyBox(){ /* theme: Ella apna buy column khud rakhta hai */ }

/* ---------- share + wishlist ---------- */
const toast = DA.el('toast');
function flash(msg){ toast.textContent = msg; toast.classList.add('on'); setTimeout(()=>toast.classList.remove('on'), 1600); }
DA.el('shareBtn').addEventListener('click', async () => {
  const data = { title: document.title, url: location.href };
  if (navigator.share) { try { await navigator.share(data); return; } catch(e){} }
  try { await navigator.clipboard.writeText(location.href); flash('Link copied'); }
  catch(e){ flash('Copy failed'); }
});
const wish = DA.el('wishBtn');
wish.addEventListener('click', () => {
  const on = wish.getAttribute('aria-pressed') === 'true';
  wish.setAttribute('aria-pressed', String(!on));
  flash(on ? 'Removed from wishlist' : 'Saved to wishlist');
  /* production: localStorage 'da_wishlist' — wahi key jo da-wishlist section padhta hai */
});

/* ============================================================
   DELIVERY ESTIMATE
   Cutoff: har din 11:00 AM ko ship hota hai.
   11 se pehle order = aaj dispatch. 11 ke baad = agla working day.
   Working days Mon–Sat maane hain (Sunday off) — confirm karna hai.
   Zone days: Delhi NCR warehouse se maane hain — confirm karna hai.
   ============================================================ */
const ZONE = {
  '1':{n:'Delhi / NCR, Punjab, Haryana, HP, J&K', d:2},
  '2':{n:'Uttar Pradesh, Uttarakhand',            d:3},
  '3':{n:'Rajasthan, Gujarat',                    d:3},
  '4':{n:'Maharashtra, MP, Chhattisgarh, Goa',    d:4},
  '5':{n:'Telangana, Andhra, Karnataka',          d:5},
  '6':{n:'Tamil Nadu, Kerala',                    d:5},
  '7':{n:'West Bengal, Odisha, North-East',       d:5},
  '8':{n:'Bihar, Jharkhand',                      d:4}
};
const STATE2ZONE = {DL:'1',HR:'1',PB:'1',HP:'1',JK:'1',CH:'1',LA:'1',UP:'2',UK:'2',RJ:'3',GJ:'3',DN:'3',MH:'4',MP:'4',CT:'4',GA:'4',TG:'5',AP:'5',KA:'5',TN:'6',KL:'6',PY:'6',WB:'7',OR:'7',OD:'7',AS:'7',SK:'7',ML:'7',MN:'7',MZ:'7',NL:'7',TR:'7',AR:'7',BR:'8',JH:'8'};
let PLACE = { label:'India', zone:'4' };

function istNow(){
  /* IST me abhi kya time hai */
  return new Date(new Date().toLocaleString('en-US',{timeZone:'Asia/Kolkata'}));
}
function addWorkingDays(from, n){
  const d = new Date(from);
  while (n > 0){ d.setDate(d.getDate()+1); if (d.getDay() !== 0) n--; }
  return d;
}
function computeDelivery(){
  const now = istNow();
  const todayCut = new Date(now); todayCut.setHours(11,0,0,0);
  const beforeCutoff = now < todayCut && now.getDay() !== 0;
  /* agla cutoff — aaj 11 baje, warna agle working day 11 baje */
  const nextCut = beforeCutoff ? todayCut : (()=>{ const d = addWorkingDays(now,1); d.setHours(11,0,0,0); return d; })();
  const eta = addWorkingDays(nextCut, ZONE[PLACE.zone].d);
  /* countdown hamesha dikhta hai — agle cutoff tak */
  const ms = nextCut - now;
  const left = { h: Math.floor(ms/3600000), m: Math.floor(ms%3600000/60000) };
  return { eta, left, beforeCutoff, nextCut };
}
function fmt(d){
  return d.toLocaleDateString('en-IN',{weekday:'long', day:'numeric', month:'short'});
}
/* size badalne pe price, MRP, prepaid saving aur sticky bar — sab sync */
function setPrice(price, mrp){
  const n = +price.replace(/,/g,'');
  document.querySelector('.price .amt').textContent = '₹' + price;
  document.querySelector('.price .mrp s').textContent = '₹' + mrp;
  const save = Math.round(n * 0.05);
  /* prepaid do jagah dikhta hai — MRP ke neeche aur offers list me */
  document.querySelectorAll('[data-prepaid]').forEach(e => e.textContent = `Save ₹${save} more`);
  document.querySelectorAll('[data-prepaid-t]').forEach(e =>
    e.textContent = `Save ₹${save} — 5% off on prepaid`);
  document.querySelector('.sticky .info b').innerHTML =
    `₹${price} <span class="mrp"><s>₹${mrp}</s></span>`;
}

/* "X+ bought this month" — asli number ko neeche round karke + lagate hain,
   taaki 22 ka "22" nahi, "20+" dikhe. 10 se kam ho to badge hi chhupa dete hain. */
const UNITS_30D = 22;
function boughtLabel(n){
  if (n < 10) return null;
  const step = n < 100 ? 10 : n < 1000 ? 50 : 100;
  return (Math.floor(n / step) * step).toLocaleString('en-IN') + '+';
}
function renderBought(){
  const lbl = boughtLabel(UNITS_30D);
  const box = document.querySelector('.bought');
  if (!lbl){ box.style.display = 'none'; return; }
  DA.el('boughtN').textContent = lbl;
}

/* key-spec table bhi size ke saath badalti hai */
const SIZESPEC = {
  '3.7 inch': {d:'11 × 7.5 × 5 cm', s:'3.7 inch tall',  w:'Approx. 170 g'},
  '5 inch':   {d:'13 × 9 × 6 cm',   s:'5 inch tall',    w:'Approx. 310 g'},
  '7 inch':   {d:'18 × 12 × 8 cm',  s:'7 inch tall',    w:'Approx. 640 g'}
};
function setKeySpec(size){
  const s = SIZESPEC[size]; if (!s) return;
  const kz = DA.el('kSize'), kw = DA.el('kWeight');
  if (kz) kz.innerHTML = `${s.d} <small>${s.s}</small>`;
  if (kw) kw.textContent = s.w;
}

/* ⚠ Yahan pehle mockup ke HARDCODED numbers pade the:
       const RATING = 5.0, RCOUNT = 6;
   ...aur renderStars() unse `.fgs` ki width aur `#ratingCnt` ka text har page
   par overwrite kar deta tha. Natija: HAR product par `(6)` aur stars hamesha
   100%. Naapa (elephant): Judge.me khud "Based on 55 reviews" keh raha tha,
   metafield bhi 55 tha, par page par (6) chhap raha tha aur stars 100% par the
   jabki 4.93 ka sahi fill 98.6% hai.

   Ab asli source Liquid hai — `blocks/da-sold-rating.liquid` `reviews.rating`
   aur `reviews.rating_count` metafields se dono cheezein server par hi sahi
   chhaap deta hai (stars ki width bhi inline aa jaati hai). Isliye JS ka kaam
   sirf itna hai: agar Judge.me ka apna widget load ho chuka hai to usse SABSE
   TAAZA count utha lo, kyunki metafield ka sync peeche reh sakta hai
   (naapa: rating 24 Jul ko sync hua tha, rating_count 27 Jun ko).

   Widget na mile to kuch mat karo — Liquid wali value pehle se sahi hai. */
function renderStars(){
  const c = DA.el('ratingCnt');
  if (!c) return;
  const sum = document.querySelector('.jdgm-rev-widg__summary-text');
  const m = sum && sum.textContent.match(/([\d,]+)\s*review/i);
  if (!m) return;
  const live = parseInt(m[1].replace(/,/g, ''), 10);
  if (!isFinite(live) || live <= 0) return;
  c.textContent = '(' + live.toLocaleString('en-IN') + ')';
}

function renderDelivery(){
  const { eta, left, beforeCutoff } = computeDelivery();
  const dateEl = DA.el('delivDate');
  const cutEl  = DA.el('cutLine');
  const locEl  = DA.el('locName');
  const stick  = DA.el('stickyDeliv');
  if (dateEl) dateEl.textContent = fmt(eta);
  if (locEl)  locEl.textContent  = PLACE.label;
  if (stick)  stick.textContent  = 'FREE delivery ' + fmt(eta);
  if (cutEl){
    /* delivery line ke saath hi chalta hai — agle 11 AM dispatch tak countdown */
    cutEl.innerHTML = `If order placed within <b>${left.h} hrs ${left.m} mins</b>`;
  }
}

/* IP se sirf sheher/state — pincode nahi. Pincode user khud daale to exact.
   ⚠ IP geolocation ISP ke exit node ka sheher deta hai, shopper ka nahi — isliye
   ye kabhi-kabhi saaf galat hota hai. Isko "accurate" banane ka koi tareeka nahi
   hai; sahi jawab hai shopper ka apna pincode, jo neeche localStorage me rehta
   hai. Isliye saved pincode ho to IP ko chhua hi nahi jaata. */
/* ⚠ EK provider par bharosa mat karo. Live pe pakda gaya: `ipwho.is` khud to
   200 lautata hai, par kai shoppers ke yahan wo call CHALTI HI NAHI — ad-blocker
   / privacy extension third-party IP lookups rok deta hai, ya free API rate-limit
   kar deti hai. Purana code us soorat me chupchaap `'India'` par gir jaata tha,
   isliye Chhattisgarh ke shopper ko bhi sirf "India" dikh raha tha.

   Ab teen source ek ke baad ek try hote hain, har ek par 2.5s ka timeout. Aur
   agar teenon fail ho jaayein to jhoothi jagah dikhane ke bajaye seedha pincode
   maanga jaata hai — wahi waise bhi sabse sahi jawab hai. */
const IP_SOURCES = [
  { url: 'https://ipwho.is/',
    read: j => ({ ok: j && j.success !== false && j.country_code === 'IN',
                  city: j.city, region: j.region, code: j.region_code }) },
  { url: 'https://ipapi.co/json/',
    read: j => ({ ok: j && j.country_code === 'IN',
                  city: j.city, region: j.region, code: j.region_code }) },
  { url: 'https://get.geojs.io/v1/ip/geo.json',
    read: j => ({ ok: j && j.country_code === 'IN',
                  city: j.city, region: j.region, code: null }) }
];

/* kuch APIs Chhattisgarh ko CG kehti hain, kuch CT — dono zone 4 */
const REGION_ALIAS = { CG: 'CT', UT: 'UK', OD: 'OR' };

function zoneFor(code, region){
  if (code) {
    var c = String(code).toUpperCase();
    c = REGION_ALIAS[c] || c;
    if (STATE2ZONE[c]) return STATE2ZONE[c];
  }
  /* code na mile to state ke naam se dhoondho */
  if (region) {
    var r = String(region).toLowerCase();
    if (/chhatt|chatt/.test(r)) return '4';
    for (var z in ZONE) {
      if (ZONE[z].n.toLowerCase().split(/[,/]/).some(function(part){
        return part.trim() && r.indexOf(part.trim().toLowerCase()) > -1;
      })) return z;
    }
  }
  return '4';
}

async function fetchJSON(url, ms){
  const ctrl = new AbortController();
  const t = setTimeout(function(){ ctrl.abort(); }, ms);
  try {
    const r = await fetch(url, { signal: ctrl.signal });
    if (!r.ok) return null;
    return await r.json();
  } catch (e) {
    return null;
  } finally {
    clearTimeout(t);
  }
}

/* ============================================================
   EXACT LOCATION — GPS/WiFi
   IP se accurate location AA HI NAHI SAKTI: wo ISP ke exit node ka sheher deta
   hai. Ek hi bharosemand tareeka hai browser ki apni Geolocation, jiske liye
   browser ek baar permission maangta hai — iske bina koi bhi tareeka accurate
   nahi ho sakta, ye browser ki paabandi hai.

   Permission mil jaane ke baad ye AUTOMATIC ho jaata hai: agle visit par bina
   poochhe chalta hai (`permissions.query` se pehle hi jaanch lete hain), aur
   nikla hua pincode localStorage me save rehta hai.

   Reverse geocode BigDataCloud ke client-side endpoint se — koi API key nahi,
   aur wo seedha `postcode` deta hai, yani asli 6-digit pincode.
   ============================================================ */
function geoPosition(){
  return new Promise(function(resolve, reject){
    if (!navigator.geolocation) return reject(new Error('unsupported'));
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true, timeout: 10000, maximumAge: 10 * 60 * 1000
    });
  });
}

async function useExactLocation(){
  /* ⚠ Label ko yahan "locating…" mat karo. Prompt khula rehta hai jab tak
     shopper jawab na de — aur agar wo use anदekha kar de to label hamesha ke
     liye "locating…" par atak jaata. IP wala anumaan dikhta rehne do; asli
     jagah milte hi wo apne aap replace ho jaayegi. */
  try {
    var pos = await geoPosition();
    var lat = pos.coords.latitude, lon = pos.coords.longitude;

    var j = await fetchJSON(
      'https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' +
      lat + '&longitude=' + lon + '&localityLanguage=en', 6000);

    if (j && j.countryCode === 'IN') {
      var pin  = (j.postcode || '').replace(/\D/g, '').slice(0, 6);
      var city = j.city || j.locality || '';
      var st   = j.principalSubdivision || '';

      if (/^[1-9][0-9]{5}$/.test(pin)) {
        /* asli pincode mil gaya — yahi sabse sahi hai, aur zone bhi isi se */
        PLACE = { label: (city ? city + ' · ' : '') + pin, zone: pin.charAt(0) };
        try { localStorage.setItem(PIN_KEY, pin); } catch (e) {}
        var inp = document.querySelector('[data-pininput]');
        if (inp) inp.value = pin;
      } else {
        PLACE = { label: (city ? city + ', ' : '') + (st || 'India'), zone: zoneFor(null, st) };
      }
      hideGeoButton();
      renderDelivery();
      return true;
    }
  } catch (e) {
    /* user ne mana kar diya, ya GPS nahi mila */
  }

  renderDelivery();
  return false;
}

function hideGeoButton(){ /* koi button nahi hai — sab automatic */ }

/* ---- Location apne aap ----
   Koi button nahi. Page load par hi GPS/WiFi maang lete hain.

   ⚠ Permission ka prompt browser dikhayega — ye BROWSER KI PAABANDI hai, koi
   code use bypass nahi kar sakta. Bina shopper ki ijazat ke asli location kisi
   bhi tareeke se nahi mil sakti. Ek baar allow ho gaya to `permissions.query`
   agli har visit par 'granted' bata deta hai, aur tab bina kuch poochhe chalta
   hai — yahi "automatic" wala anubhav hai.

   Deny/dismiss ho jaaye to chupchaap IP wale anumaan par reh jaate hain aur
   dobara tang nahi karte. */
async function wireGeo(){
  var host = document.querySelector('.deliv');
  if (host && host.dataset.autogeo === '0') return;
  if (!navigator.geolocation) return;

  if (savedPin()) return;   /* pehle se pincode pata hai — kuch maangne ki zarurat nahi */

  var state = null;
  try {
    if (navigator.permissions && navigator.permissions.query) {
      var st = await navigator.permissions.query({ name: 'geolocation' });
      state = st.state;
      /* settings me baad me allow karein to turant pakad lo */
      st.onchange = function(){ if (st.state === 'granted') useExactLocation(); };
    }
  } catch (e) {}

  if (state === 'denied') return;

  /* 'granted' ho to bina prompt ke chalta hai; 'prompt' ho to browser khud
     puchhega. Load ke turant baad nahi — pehle page bas jaane do. */
  setTimeout(function(){ useExactLocation(); }, state === 'granted' ? 0 : 1200);
}

async function detectByIP(){
  if (savedPin()) return;

  for (var i = 0; i < IP_SOURCES.length; i++){
    var src = IP_SOURCES[i];
    var j = await fetchJSON(src.url, 2500);
    if (!j) continue;

    var got;
    try { got = src.read(j); } catch (e) { continue; }
    if (!got || !got.ok) continue;

    var label = (got.city ? got.city + ', ' : '') + (got.region || 'India');
    PLACE = { label: label, zone: zoneFor(got.code, got.region) };
    renderDelivery();
    return;
  }

  /* Sab fail. Jhooth mat bolo — pincode maango. */
  PLACE = { label: 'Set pincode', zone: '4' };
  renderDelivery();
}

/* ---------- pincode wiring (asli theme) ----------
   ⚠ "Change pincode" button DEAD tha. Wajah: use `wireBuyBox()` wire karta hai,
   aur `wireBuyBox()` ka akela caller `mountBuyBox()` hai — jo asli theme par ek
   KHAALI STUB hai (Ella apna buy column khud rakhta hai). Yaani wiring kabhi
   chali hi nahi: toggle par form `.on` class kabhi nahi lagti thi.

   `wireBuyBox(document)` chala dena galat hota — wo mockup ke `.vopts` chips aur
   `[data-q]` qty buttons bhi wire karta hai, jo asli theme par DA variant picker
   aur Ella ka apna stepper pehle se sambhalte hain. Do handler ek hi DOM par
   ladte (ye is project me pehle bhi ho chuka hai). Isliye sirf pincode wala
   hissa alag se wire karte hain.

   Saath me pincode localStorage me yaad bhi rakhte hain — IP se sirf sheher ka
   andaza lagta hai (aur wo aksar ISP ka sheher hota hai, shopper ka nahi), jabki
   khud daala hua pincode exact hota hai. Isliye saved pincode HAMESHA IP se
   jeetta hai. */
var PIN_KEY = 'da_pincode';

function placeFromPin(v){
  var z = v.charAt(0);
  /* ⚠ Sirf PINCODE dikhao. Pehle yahan zone ka naam jud jaata tha
     (`ZONE['1'].n.split(',')[0]` => "Delhi / NCR"), jo ek delivery-zone ka
     label hai, shopper ke sheher ka naam nahi — 110052 ke saath "Delhi / NCR"
     likhna galat lagta tha. Pincode se sheher nikaalne ke liye lookup chahiye,
     jo abhi nahi hai; isliye jo sach me pata hai wahi dikhate hain. */
  return { label: v, zone: ZONE[z] ? z : '4' };
}

function savedPin(){
  try { var v = localStorage.getItem(PIN_KEY); return /^[1-9][0-9]{5}$/.test(v || '') ? v : null; }
  catch (e) { return null; }
}

function wirePincode(){
  var tog  = document.querySelector('[data-pintoggle]');
  var form = document.querySelector('[data-pinform]');
  var inp  = document.querySelector('[data-pininput]');
  var err  = document.querySelector('[data-pinerr]');
  if (!tog || !form || !inp) return;

  var pin = savedPin();
  if (pin) { inp.value = pin; PLACE = placeFromPin(pin); renderDelivery(); }

  tog.addEventListener('click', function(){
    form.classList.toggle('on');
    if (form.classList.contains('on')) inp.focus();
  });

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var v = (inp.value || '').trim();
    if (!/^[1-9][0-9]{5}$/.test(v)){ err && err.classList.add('on'); return; }
    err && err.classList.remove('on');
    PLACE = placeFromPin(v);
    try { localStorage.setItem(PIN_KEY, v); } catch (e2) {}
    form.classList.remove('on');
    renderDelivery();
  });
}

/* ---------- buy box ke andar ki wiring (sirf mockup) ---------- */
function wireBuyBox(scope){
  const tog  = scope.querySelector('[data-pintoggle]');
  const form = scope.querySelector('[data-pinform]');
  const inp  = scope.querySelector('[data-pininput]');
  const err  = scope.querySelector('[data-pinerr]');
  tog && tog.addEventListener('click', () => { form.classList.toggle('on'); inp.focus(); });
  form && form.addEventListener('submit', e => {
    e.preventDefault();
    const v = (inp.value || '').trim();
    if (!/^[1-9][0-9]{5}$/.test(v)){ err.classList.add('on'); return; }
    err.classList.remove('on');
    const z = v[0];
    PLACE = { label: v + ' · ' + (ZONE[z] ? ZONE[z].n.split(',')[0] : 'India'), zone: ZONE[z] ? z : '4' };
    form.classList.remove('on');
    renderDelivery();
  });
  /* variant chips */
  scope.querySelectorAll('.vopts').forEach(grp => grp.addEventListener('click', e => {
    const b = e.target.closest('.vopt'); if (!b || b.disabled) return;
    grp.querySelectorAll('.vopt').forEach(x => x.removeAttribute('aria-current'));
    b.setAttribute('aria-current','true');
    /* size badla -> gallery aur price dono badle */
    if (grp.dataset.vgroup === 'size'){
      activeSize = b.dataset.lbl; activeShot = 0;
      renderGallery();
      setPrice(b.dataset.price, b.dataset.mrp);
      setKeySpec(b.dataset.lbl);
    }
  }));
  scope.querySelectorAll('[data-q]').forEach(b => b.addEventListener('click', () => {
    const box = scope.querySelector('[data-qv]');
    let n = +box.textContent + (b.dataset.q === '+' ? 1 : -1);
    box.textContent = Math.max(1, Math.min(20, n));
  }));
}

/* ============================================================
   FAQ — categorised. Production me `custom.faqs` (json) me
   har question ke saath ek `cat` field aayega, aur variant-specific
   sawaal `variant.custom.variant_faq` se prepend honge.
   ============================================================ */
const FAQS = window.DA_FAQS && window.DA_FAQS.length ? window.DA_FAQS : [
 {c:'size',    v:'3.7 inch', q:'Will this 3.7 inch idol stay steady on a car dashboard?', a:'Yes. It sits on a flat wooden base and is 170 g — heavy enough not to slide on normal driving. Use an anti-slip mat under it; do not stick adhesive on the base, it will lift the plating when removed.'},
 {c:'size',    v:'3.7 inch', q:'Is 3.7 inches too small for a home temple?',              a:'It is 11 cm tall — right for a shelf mandir, a study table or an office desk, and it looks correct next to standard-size diyas. If your mandir is floor-standing and you want the idol to be the centrepiece, go a size up.'},
 {c:'material',v:'',         q:'Is this real silver plating? Will it tarnish over time?', a:'Yes — genuine 999-grade silver plating over a resin core, not paint or lacquer, and it ships with a Certificate of Authenticity. Like all silver, the surface can slowly dull if exposed to humidity, perfume, agarbatti smoke or cleaning chemicals. That is a natural property of silver, not a defect. The anti-tarnish finish slows it considerably.'},
 {c:'material',v:'',         q:'How do I clean and care for it?',                        a:'Wipe with a soft dry cotton cloth. Never wash it, never soak it, and never use metal polish, Brasso, toothpaste or a scrubber — those strip the plating. Keep it out of direct water and away from incense smoke.'},
 {c:'material',v:'',         q:'What is it actually made of?',                           a:'A durable resin core, electroplated in 999-grade silver and hand-buffed, on a wooden plinth. Resin rather than solid silver keeps it affordable and dent-free — you get the silver surface and the detail at a fraction of solid-silver cost.'},
 {c:'material',v:'',         q:'Is a Certificate of Authenticity included?',             a:'Yes — a signed card in every box stating the plating grade and the unit that produced your piece.'},
 {c:'gifting', v:'',         q:'Does it come with gift packaging?',                      a:'Yes, always. Every order arrives in our Signature Teal Velvet Box with a smooth satin lining, inside a protective shipping carton. No extra charge and nothing more to wrap — it is gift-ready as it lands.'},
 {c:'gifting', v:'',         q:'Can I get it engraved or personalised?',                 a:'Yes, for occasions and corporate orders. We can engrave the base or supply customised packaging with your message or logo. Share the occasion and quantity on WhatsApp and our team will come back with options and pricing.'},
 {c:'gifting', v:'',         q:'Do you offer bulk or corporate pricing?',                a:'Yes. We supply corporate gifting, wedding return gifts and festival hampers at volume pricing. Send your quantity and budget on WhatsApp or to support@devaastha.com and we will share a customised quote — branded packaging included if you need it.'},
 {c:'order',   v:'',         q:'How long will delivery take?',                           a:'We dispatch every day by 11 AM. Metro cities typically receive in 2–4 days, rest of India in 4–7 days. You get a tracking link by SMS and WhatsApp as soon as it ships. Shipping is free across India on prepaid orders.'},
 {c:'order',   v:'',         q:'What if it arrives damaged?',                            a:'Report it within 24 hours with a photo and we will replace it — no argument, no return shipping cost to you. Our packing makes this rare, but when it happens we treat it as our problem.'},
 {c:'order',   v:'',         q:'What is the return policy?',                             a:'Seven days from delivery if the piece does not meet your expectations. It must come back unused and in its original velvet box and carton. Engraved and made-to-order pieces cannot be returned.'}
];
/* desktop pe SAARE questions dikhte hain, mobile pe pehle 4 */
const faqFirst = () => DA.view() === 'desktop' ? FAQS.length : 4;
let faqCat = 'all', faqAll = false;

function renderFaq(){
  const FAQ_FIRST = faqFirst();
  const list = FAQS.filter(f => faqCat === 'all' || f.c === faqCat);
  const show = faqAll ? list : list.slice(0, FAQ_FIRST);
  const box  = DA.el('faqList');
  box.innerHTML = show.length
    ? show.map(f => `<div class="fitem" data-open="false">
        <button class="fq"><span>${f.q}</span><span class="pm"></span></button>
        <div class="fa"><div><p>${f.a}</p></div></div></div>`).join('')
    : '<p class="sub" style="padding-block:16px">Is category me abhi koi sawaal nahi.</p>';
  box.querySelectorAll('.fitem').forEach(it => {
    it.querySelector('.fq').addEventListener('click', () => {
      it.dataset.open = it.dataset.open === 'true' ? 'false' : 'true';
    });
  });
  /* Desktop: saare FAQ pehle se khule hain -> sirf "Talk to us".
     Mobile : pehle sirf "Still have more questions?" -> click pe FAQ khulte hain
              aur tabhi "Still confused? Talk to us" dikhta hai. */
  const more = DA.el('faqMore');
  const talk = DA.el('faqTalk');
  const desktop = DA.view() === 'desktop';
  const hasMore = list.length > faqFirst();
  more.style.display = (!desktop && hasMore && !faqAll) ? '' : 'none';
  talk.style.display = (desktop || faqAll || !hasMore) ? '' : 'none';
}
/* ⚠ Category pills 11 Aug 2026 ko hata di gayin — `#fchips` ab render hi nahi
   hota, isliye `DA.el` yahan NOOP Proxy lautata hai aur ye listener chup-chaap
   kahin nahi lagta. `faqCat` 'all' par tika rehta hai = saare sawaal ek list me.
   Pills wapas aayen to ye code jaisa hai waisa hi chal padega. */
DA.el('fchips').addEventListener('click', e => {
  const c = e.target.closest('.fchip'); if (!c) return;
  faqCat = c.dataset.cat; faqAll = false;
  document.querySelectorAll('.fchip').forEach(x => x.setAttribute('aria-pressed', String(x === c)));
  renderFaq();
});
DA.el('faqMore').addEventListener('click', () => { faqAll = !faqAll; renderFaq(); });

/* ============================================================
   VARIANT-AWARE GALLERY
   Har media ka ek group hota hai: 'all' = common (har variant pe dikhta),
   ya variant ka naam = sirf usi variant pe dikhta.
   Production me ye group media ke ALT TEXT ke '#key' suffix se aata hai —
   koi app nahi, koi naya metafield nahi, Shopify ke media grid me editable.
   ============================================================ */
const CDN = 'https://cdn.shopify.com/s/files/1/0702/1789/2058/files/';
/* v:true = VIDEO. Abhi is product pe koi video nahi hai (saare 6 media IMAGE hain),
   ye entry sirf ye dikhane ke liye hai ki video aane par slider kaisa behave karega. */
const MEDIA = window.DA_MEDIA && window.DA_MEDIA.length ? window.DA_MEDIA : [
  /* NOTE: Shopify pe is image ka asli alt "dark-green velvet gift box" hai —
     agar naam "Signature Teal Velvet Box" hai to alt bhi update karna padega */
  {t:'Ganesha idol in the Signature Teal Velvet Box with diyas behind', g:'all',   src:CDN+'1_eac4b6fd-a852-43fe-a7a0-be30c5103114.jpg?v=1779434618&width=900'},
  {t:'Size chart — 3.7 inch',                                        g:'3.7 inch', src:CDN+'2_b92767e8-fe75-4262-b66a-8bf2ae36c56e.jpg?v=1779434618&width=900'},
  {t:'On a car dashboard — compact murti',                           g:'3.7 inch', src:CDN+'3_f6df7c45-3dbb-4eb9-8f7e-931d3aab6982.jpg?v=1779434618&width=900'},
  {t:'Product video — 360° spin',                                    g:'all',      v:true, src:CDN+'6_a1d5332f-90d0-4ee3-b423-5d1b0ade512a.jpg?v=1779434618&width=900'},
  /* 5" aur 7" ki photos abhi hain hi nahi — placeholder, filtering dikhane ke liye */
  {t:'Size chart 5" — photo pending',                                g:'5 inch'},
  {t:'5" in home mandir — photo pending',                            g:'5 inch'},
  {t:'Size chart 7" — photo pending',                                g:'7 inch'},
  {t:'7" on console table — photo pending',                          g:'7 inch'},
  {t:'In a wooden home mandir with diya and marigold',               g:'all',      src:CDN+'4_eb781152-e9b7-4263-8d92-f689cd9eb7ea.jpg?v=1779434618&width=900'},
  {t:'Vastu placement guide',                                        g:'all',      src:CDN+'5_ce186ca6-f212-47c1-a57d-048a35ed82b4.jpg?v=1779434618&width=900'},
  {t:'Resin core with premium silver plating',                       g:'all',      src:CDN+'6_a1d5332f-90d0-4ee3-b423-5d1b0ade512a.jpg?v=1779434618&width=900'}
];
let activeSize = '3.7 inch', activeShot = 0;

function visibleMedia(){
  /* variant ka media + common media — baaki variants ka nahi */
  return MEDIA.filter(m => m.g === 'all' || m.g === activeSize);
}
/* asli photo ho to <img>, warna placeholder. Video pe play overlay. */
const PLAY = `<span class="playmark"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></span>`;
const shot = (m, big, i) => (m.src
  ? `<img src="${m.src}" alt="${m.t}" width="900" height="900" loading="${i===0 ? 'eager' : 'lazy'}" ${i===0 ? 'fetchpriority="high"' : ''} decoding="async">`
  : `<div class="ph">${m.t}</div>`) + (m.v ? PLAY.replace('playmark', big ? 'playmark playmark--lg' : 'playmark') : '');

function renderGallery(){
  const list = visibleMedia();
  if (activeShot >= list.length) activeShot = 0;

  /* mobile: har media apni slide, scroll-snap row me (asli swipe).
     desktop: sirf active slide dikhti hai, thumb rail se chalti hai. */
  DA.el('shotRow').innerHTML = list.map((m,i) =>
    `<div class="shot${m.v?' shot--video':''}" data-i="${i}">${shot(m, true, i)}</div>`).join('');

  DA.el('rail').innerHTML = list.map((m,i) =>
    `<button type="button" class="${m.v?'is-video':''}" aria-current="${i===activeShot}" aria-label="View image ${i+1} of ${list.length}: ${m.t}">${shot(m, false, -1)}</button>`).join('');

  DA.el('dots').innerHTML = list.map((m,i) => m.v
    ? `<i role="button" tabindex="0" aria-label="Play product video" class="vdot ${i===activeShot?'on':''}" data-i="${i}"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></i>`
    : `<i role="button" tabindex="0" aria-label="Go to image ${i+1}" class="${i===activeShot?'on':''}" data-i="${i}"></i>`).join('');

  DA.el('rail').querySelectorAll('button').forEach((b,i) =>
    b.addEventListener('click', () => { activeShot = i; renderGallery(); }));

  syncStage();
}

/* desktop pe sirf active slide; mobile pe scroll position se active nikalta hai */
function syncStage(){
  const row = DA.el('shotRow');
  const desktop = DA.view() === 'desktop';
  row.querySelectorAll('.shot').forEach((el,i) =>
    el.style.display = (desktop && i !== activeShot) ? 'none' : '');
  if (!desktop) row.scrollLeft = activeShot * row.clientWidth;
}

function markDot(i){
  document.querySelectorAll('#dots i').forEach((d,j) => d.classList.toggle('on', j===i));
  document.querySelectorAll('#rail button').forEach((b,j) => b.setAttribute('aria-current', j===i));
}

/* Judge.me ka widget async aata hai — pehli koshish par shayad DOM me na ho.
   Isliye do baar aur dekh lete hain. renderStars() surakshit hai: widget na
   mile to wo kuch badalta hi nahi, aur Liquid wali sahi value bani rehti hai. */
renderStars();
setTimeout(renderStars, 1200);
setTimeout(renderStars, 3500);
renderBought();
renderFaq();
renderGallery();
mountBuyBox();
applyView();
/* ---------- Qty: sirf − aur + se badle, type karke nahi ----------
   Phone par ginti par tap karte hi numeric keyboard khul jaata tha aur poora
   page uchhal jaata tha. Yahan sirf do button chahiye.

   `readonly` use kiya hai, `disabled` NAHI — disabled input form ke saath
   submit hi nahi hota, jisse quantity cart tak pahunchti hi na. readonly par
   value form me jaati hai aur theme ka apna quantity-input use badal bhi
   sakta hai (readonly sirf USER ki typing rokta hai, script ki nahi).
   `inputmode=none` + CSS `pointer-events:none` se tap par focus hi nahi hota. */
function lockQtyInput(){
  var inp = document.querySelector('.product-information__grid quantity-input .quantity__input');
  if (!inp) return;
  inp.readOnly = true;
  inp.setAttribute('inputmode', 'none');
  inp.setAttribute('tabindex', '-1');
  inp.setAttribute('aria-readonly', 'true');
}

wirePincode();   /* mountBuyBox() khaali stub hai — pincode ise chahiye */
lockQtyInput();
wireGeo();       /* permission mil chuki ho to exact location apne aap */
detectByIP();
setInterval(renderDelivery, 30000);

/* ============================================================
   PREMIUM POLISH — vanilla, null-safe, reduced-motion aware.
   Sirf transform/opacity chalte hain.
   ============================================================ */
(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal ---- */
  function wire(){
    var els = document.querySelectorAll('.da-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)){
      els.forEach(function(e){ e.classList.add('is-in'); }); return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en, i){
        if (!en.isIntersecting) return;
        var el = en.target;
        setTimeout(function(){ el.classList.add('is-in'); }, Math.min(i * 75, 375));
        io.unobserve(el);
      });
    }, { threshold:.12, rootMargin:'0px 0px -6% 0px' });
    els.forEach(function(e){ io.observe(e); });
  }
  wire();
  /* view toggle ke baad naye elements bhi wire ho jayen */
  var seg = DA.el('viewseg');
  if (seg) seg.addEventListener('click', function(){ setTimeout(wire, 60); });

  /* ---- images: load hone pe fade ---- */
  document.querySelectorAll('img').forEach(function(im){
    if (im.complete) return;
    im.setAttribute('data-loading','');
    im.addEventListener('load',  function(){ im.removeAttribute('data-loading'); }, { once:true });
    im.addEventListener('error', function(){ im.removeAttribute('data-loading'); }, { once:true });
  });


  /* ---- product tabs: ek waqt me ek hi khula (accordion) ----
     ⚠ Yahan page "apne aap scroll" ho jaata tha. Wajah ye nahi thi ki koi
     scroll kar raha tha — jab neeche wala accordion khulta hai, UPAR wale band
     ho jaate hain, upar ka content chhota ho jaata hai, par browser ka
     scrollTop wahi rehta hai. Natija: jis header par aapne click kiya wo
     upar khisak jaata hai aur page kood gaya lagta hai.

     Ilaaj: band karne se PEHLE us header ki viewport position naap lo, band
     karne ke BAAD dobara naapo, aur utna hi scroll adjust kar do. Header
     wahin ka wahin dikhta hai. */
  var tabs = document.querySelectorAll('.ptabs details');
  tabs.forEach(function(d){
    d.addEventListener('toggle', function(){
      if (!d.open) return;
      var head = d.querySelector('summary') || d;
      var before = head.getBoundingClientRect().top;
      tabs.forEach(function(o){ if (o !== d) o.open = false; });
      var delta = head.getBoundingClientRect().top - before;
      /* 1px se kam ka farq nazar nahi aata — bekaar ka scroll mat karo */
      if (Math.abs(delta) > 1) scrollBy(0, delta);
    });
  });
})();

/* ---------- mobile motion ---------- */
(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* gallery swipe -> dots sync (scroll position se) */
  var row = DA.el('shotRow');
  if (row){
    var t;
    row.addEventListener('scroll', function(){
      if (DA.view() === 'desktop') return;
      clearTimeout(t);
      t = setTimeout(function(){
        var i = Math.round(row.scrollLeft / row.clientWidth);
        if (i !== activeShot){ activeShot = i; markDot(i); }
      }, 60);
    }, { passive:true });
  }

  /* dot tap -> us slide pe scroll */
  var dots = DA.el('dots');
  if (dots) dots.addEventListener('click', function(e){
    var d = e.target.closest('i'); if (!d || !row) return;
    var i = +d.dataset.i;
    activeShot = i; markDot(i);
    row.scrollTo({ left: i * row.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* pehli baar swipe hint — sirf mobile, sirf ek baar */
  /* ⚠ `row` `DA.el()` se aata hai, jo element na mile to ek NOOP Proxy lautata
     hai. Wo truthy hai, isliye purana `if (row)` paas ho jaata tha aur
     `observe()` ko non-Element mil jaata tha -> TypeError, jisse baaki PDP
     JS ruk sakta tha. Isliye asli Element ki jaanch. */
  if (!reduce && row instanceof Element) {
    var hinted = false;
    var hio = new IntersectionObserver(function(en){
      if (!en[0].isIntersecting || hinted || DA.view() === 'desktop') return;
      hinted = true; row.classList.add('peek-hint');
      setTimeout(function(){ row.classList.remove('peek-hint'); }, 2400);
      hio.disconnect();
    }, { threshold:.6 });
    hio.observe(row);
  }

  /* Sticky bar: NEECHE scroll par dikhe, UPAR scroll par chhup jaye.
     (Pehle ulta tha — neeche jaate hi chhup jaati thi.)
     Soch: neeche scroll = grahak product padh raha hai aur kharidne ki taraf
     badh raha hai, wahin ATC saamne chahiye. Upar scroll = wo wapas gallery
     ya title dekhne ja raha hai, tab bar raste se hat jaye.

     Top ke 240px me hamesha chhupi — wahan asli buy box khud saamne hai. */
  var bar = document.querySelector('.sticky'), last = 0;
  if (bar) {
    /* Shuru me chhupi — top par bar dikhani hi nahi hai, aur pehli baar neeche
       scroll karte hi transition se slide hoke aayegi (yahi intro hai).

       Cancel: agar kisi purane cached CSS se `daUp` jaisi transform-animation
       abhi bhi chipki ho to wo `is-away` ko harakar bar ko jaam kar degi.
       Isliye bar par transform chhune wali har animation cancel kar dete hain —
       wahi tareeka jo buy-box ke rang wale jaal me kaam aaya tha. */
    bar.getAnimations().forEach(function(a){
      var touchesTransform = false;
      try {
        touchesTransform = a.effect.getKeyframes().some(function(k){ return 'transform' in k; });
      } catch (e) { touchesTransform = true; }
      if (touchesTransform) a.cancel();
    });
    bar.classList.add('is-away');
  }
  if (bar) addEventListener('scroll', function(){
    var y = scrollY;
    /* 6px ka dead zone — warna ungli ke halke se kaanpne par bar jhilmilati hai */
    if (Math.abs(y - last) > 6) {
      var down = y > last;
      bar.classList.toggle('is-away', !down || y <= 240);
    }
    last = y;
  }, { passive:true });

  /* Add to cart -> turant confirm feedback (touch pe hover nahi hota) */
  document.addEventListener('click', function(e){
    var b = e.target.closest('.btn--atc'); if (!b) return;
    var old = b.textContent;
    b.classList.add('is-added'); b.textContent = 'Added ✓';
    setTimeout(function(){ b.classList.remove('is-added'); b.textContent = old; }, 1400);
  });

  /* view toggle -> stage dobara sync */
  var seg = DA.el('viewseg');
  if (seg) seg.addEventListener('click', function(){ setTimeout(function(){ if (window.syncStage) syncStage(); }, 80); });
})();

/* FAQPage JSON-LD — FAQS array se generate, taaki markup aur schema kabhi diverge na hon */
(function(){
  var el = DA.el('faq-ld'); if (!el || typeof FAQS === 'undefined') return;
  el.textContent = JSON.stringify({
    "@context":"https://schema.org","@type":"FAQPage",
    "mainEntity": FAQS.map(function(f){
      return {"@type":"Question","name":f.q,
              "acceptedAnswer":{"@type":"Answer","text":f.a}};
    })
  });
})();

})();
